// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { Action } from 'redux';

import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { ExtractContent } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';
import { EncryptionActionType } from './EncryptContentAction';


export interface CancelExtractTaskAction extends Action {
  contentArray: IContentInfo[];
  cancelCreation: boolean;
  encryptionActionType?: EncryptionActionType;
}

export function cancelExtractAction(contentArray: IContentInfo[], cancelCreation: boolean, encryptionActionType?: EncryptionActionType): CancelExtractTaskAction {
  return {
    type: ExtractContent,
    contentArray: contentArray,
    cancelCreation: cancelCreation,
    encryptionActionType: encryptionActionType

  };
}

export const isCancelExtractCreationAction = isActionFactory<CancelExtractTaskAction>(ExtractContent);
